export const API_CLIENT_TYPES = Object.freeze({
  BFF: 'bff',
  PUBLIC: 'public',
  EXTERNAL: 'external'
});

// Keep this list explicit so adding a new API slice cannot silently opt into
// cookie credentials or opt out of the shared CSRF-aware client.
export const API_CLIENT_ALLOWLIST = Object.freeze({
  [API_CLIENT_TYPES.BFF]: Object.freeze([
    'authApi',
    'donateRecordsApi',
    'donateVariantsApi',
    'donatesApi',
    'emotesApi',
    'eventRecordsApi',
    'interactionsApi',
    'paymentOptionsApi',
    'rouletteWidgetApi',
    'userApi'
  ]),
  [API_CLIENT_TYPES.PUBLIC]: Object.freeze([
    'configApi',
    'fileApi',
    'mediasApi',
    'overlaySettingsApi'
  ]),
  [API_CLIENT_TYPES.EXTERNAL]: Object.freeze([
    'monobankApi'
  ])
});

export const isApiClientAllowlisted = (clientName, clientType) => (
  API_CLIENT_ALLOWLIST[clientType]?.includes(clientName) ?? false
);

export const assertApiClientAllowlisted = (clientName, clientType) => {
  if (!isApiClientAllowlisted(clientName, clientType)) {
    throw new Error(`API client "${clientName}" is not allowlisted as ${clientType}.`);
  }
};
